export default __webpack_public_path__ + "static/media/news6.1d0705ab.jpg";